import { maLookback } from '../../math/ma'
import { COLOR, float, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'BBPCT',
  version: 1,
  label: 'Bollinger %B',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 3,
  order: 310,
  inputs: [period('timeperiod', 20), float('nbdevup', 2, 'StdDev up', 0, 100, 0.1), float('nbdevdn', 2, 'StdDev down', 0, 100, 0.1), matype()],
  outputs: [line('pctb', '%B', COLOR.purple)],
  levels: [{ value: 1 }, { value: 0 }],
  // Undefined (NaN) on a bar whose band width is exactly 0 (a window of identical closes).
  talib: {
    functions: ['BBANDS'],
    expr: '(close - lowerband) / (upperband - lowerband) where upperband, middleband, lowerband = BBANDS(close, timeperiod={timeperiod}, nbdevup={nbdevup}, nbdevdn={nbdevdn}, matype={matype})',
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod, matype }) => maLookback(timeperiod, matype),
}
export default def
